import { mainMenu, dropdownMenu } from "./menu";
import headerInit from "./header";
import { JagSliders } from "./sliders";
import { practiceTypesCollapse, faqCollapse } from "./additional";
import { ready } from "./utils";
import { tabsLocations } from './tabsLocations.js';

ready(() => {
  JagSliders();
  mainMenu();
  dropdownMenu();
  headerInit();
  tabsLocations();
  practiceTypesCollapse();
  faqCollapse();
});
